<form class="modal__form" [formGroup]="editIntegrationForm">
  <div class="modal__subtitle">
    <h2 class="hr">
      {{ 'pages.restaurantAccount.provider' | translate }}: Boston Pizza Events API
    </h2>
  </div>

  <div class="proxy__wrapper" *ngIf="editIntegrationForm.get('proxy')">
    <mat-slide-toggle formControlName="proxy" color="primary">
      {{ 'pages.restaurantAccount.proxy' | translate }}
    </mat-slide-toggle>
    <mat-slide-toggle formControlName="proxyUnifiedMode" color="primary">
      {{ 'pages.restaurantAccount.unified' | translate }}
    </mat-slide-toggle>
  </div>

  <app-integration-bp-events-api-form [formGroup]="editIntegrationForm"></app-integration-bp-events-api-form>

  <div class="modal__submit-btn">
    <button class="btn btn__primary" [disabled]="editIntegrationForm.invalid || !editIntegrationForm.dirty" (click)="edit()">
      {{ 'pages.restaurantAccount.save' | translate }}
    </button>
    <button class="btn btn__warning" (click)="removeIntegration()">
      {{ 'pages.restaurantAccount.delete' | translate }}
    </button>
  </div>
</form>
